import React, { useEffect } from 'react';
import TagManager from 'react-gtm-module';
import ReactGA from 'react-ga4';
import { withRouter } from 'react-router-dom';
import { Field, reduxForm } from 'redux-form';
import { FormInput, FormSelect } from '.';
import validate from '../helpers/emitPersonalInformationValidate';
import focusInputOnError from '../helpers/focusInputOnError';
import { env } from '../env';

const genders = [
  {
    name: 'Masculino',
    value: 'MALE',
  },
  {
    name: 'Femenino',
    value: 'FEMALE',
  },
];

export function EmitPersonalInformationForm(props: any) {
  const {
    handleSubmit,
    history: { push },
  } = props;

  const back = () => push('/plans');

  useEffect(() => {
    window.scrollTo(0, 0);

    if (env.REACT_APP_ENVIRONMENT === 'production' || env.REACT_APP_GTM_QA_ACTIVE === 'true') {
      const tagManagerArgs = {
        dataLayer: {
          event: 'vpvPersonalInfo',
        },
        dataLayerName: 'datalayer',
      };

      TagManager.dataLayer(tagManagerArgs);

      ReactGA.send({
        hitType: 'pageview',
        location: 'salud.segurosfalabella.com/salud/datos-asegurado',
        title: 'Seguro Salud Complementario',
        user_id: sessionStorage.getItem('userId'),
      });

      // Funnel step viewed
      ReactGA.event("funnel_step_viewed", {
        'funnel_name': 'contratacion-seguro',
        'product_name': 'web-salud-complementario',
        'funnel_step_name': 'paso-datos-asegurado'
      });
    }
  }, []);

  return (
    <form onSubmit={handleSubmit} noValidate={true}>
      <div className="row justify-content-center flex-column mb-70">
        <div className="col-12 col-sm-8 col-md-7 col-lg-4 text-center mx-auto">
          <h3 className="wizard-card--title px-24">
            Datos asegurado principal
          </h3>
        </div>
        <div className="col-12 col-sm-8 col-md-6 col-lg-4 mx-auto form-group">
          <label htmlFor="birthdate">Fecha de nacimiento</label>
          <Field name="birthdate" placeholder="Fecha de nacimiento" component={FormInput} disabled={true}/>
        </div>
        <div className="col-12 col-sm-8 col-md-6 col-lg-4 mx-auto form-group">
          <label htmlFor="name">Nombre</label>
          <Field name="name" placeholder="Nombre" component={FormInput} autoFocus={true} />
        </div>
        <div className="col-12 col-sm-8 col-md-6 col-lg-4 mx-auto form-group">
          <label htmlFor="paternal">Apellido paterno</label>
          <Field
            name="paternal"
            placeholder="Apellido paterno"
            component={FormInput}
          />
        </div>
        <div className="col-12 col-sm-8 col-md-6 col-lg-4 mx-auto form-group">
          <label htmlFor="maternal">Apellido materno</label>
          <Field
            name="maternal"
            placeholder="Apellido materno"
            component={FormInput}
          />
        </div>
        <div className="col-12 col-sm-8 col-md-6 col-lg-4 mx-auto form-group">
          <label htmlFor="gender">Género</label>
          <Field
            name="gender"
            placeholder="Selecciona.."
            component={FormSelect}
            options={genders}
          />
        </div>
      </div>
      <footer className="fixed-footer-form emit-steps">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12 col-sm-8 col-md-7 col-lg-6 pdy-16 d-flex justify-content-between align-content-center align-items-center">
              <button
                className="btn white back-to-matrix col-4 d-flex justify-content-center align-content-center align-items-center"
                type="button"
                onClick={back}
              >
                <i className="material-icons">chevron_left</i>
              </button>
              <button className="btn primary go-to-contact-info col-8" type="submit">
                Continuar
              </button>
            </div>
          </div>
        </div>
      </footer>
    </form>
  );
}

export default withRouter(
  reduxForm<any, any>({
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
    form: 'proposal',
    onSubmitFail: focusInputOnError,
    validate,
  })(EmitPersonalInformationForm),
);
